module.exports = __webpack_public_path__ + "static/media/公司资质.82ed3e7d.jpg";